/**
 * ESCHER FALLS — App Store へ出る口。`ios/App/App/LinksPlugin.swift` の包み。
 *
 * ## 評価の2つの道を混同しないこと
 * - `game/review.ts`（`AppStore.requestReview`）… **こちらから頼む。押させてはいけない。**
 * - ここ（`?action=write-review`）… 利用者が自分から書きに行く。**ボタンで良い。**
 *
 * 「評価する」ボタンが呼ぶのは**必ずこちら**である。
 * `requestReview` をボタンに繋ぐのは Apple が明確に禁じている。
 */

import { Capacitor, registerPlugin } from '@capacitor/core';

interface LinksNative {
  open(options: { url: string }): Promise<{ opened: boolean }>;
}

const Links = registerPlugin<LinksNative>('Links');

/** この作品のストアページ。 */
const APP_ID = '6802934416';

/** 作者の一覧ページ。**他の作品が公開されるとここに並ぶ。** */
const DEVELOPER_ID = '6802531423';

/** 感想を書く画面を直に開く URL。 */
export const WRITE_REVIEW_URL = `https://apps.apple.com/app/id${APP_ID}?action=write-review`;

/** 作者の他の作品。 */
export const DEVELOPER_URL = `https://apps.apple.com/developer/id${DEVELOPER_ID}`;

/** 外へ出られる場所か。ボタンを出すかどうかの判定に使う。 */
export function canOpenStore(): boolean {
  return Capacitor.isNativePlatform();
}

/** App Store を開く。**失敗しても投げない。** */
export async function openStore(url: string): Promise<void> {
  if (!canOpenStore()) return;
  try {
    await Links.open({ url });
  } catch {
    // 開けなかっただけ。遊びは何も変わらない。
  }
}
